var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2,
    height: 19,
    viewBox: "0 0 2 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:var(--smd-tertiary);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-711 -304)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 19,
    transform: "translate(711 304)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 19,
    transform: "translate(711 304)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe);
export default __webpack_public_path__ + "static/media/pipe.2325fee53a940082d7fa2e461c212e65.svg";
export { ForwardRef as ReactComponent };